"use client";

import type { FileUIPart } from "ai";

import {
  Attachment,
  AttachmentInfo,
  AttachmentPreview,
  Attachments,
} from "@/components/ai-elements/attachments";
import { Image } from "@/components/ai-elements/image";

function isImageFile(file: { mediaType: string }) {
  return file.mediaType.startsWith("image/");
}

export function SentAttachments({ files }: { files: FileUIPart[] }) {
  const images = files.filter(isImageFile);
  const others = files.filter((file) => !isImageFile(file));

  return (
    <div className="flex flex-col items-end gap-2">
      {images.length === 1 ? (
        <Image
          url={images[0].url}
          mediaType={images[0].mediaType}
          alt={images[0].filename ?? ""}
          className="max-h-60 w-auto max-w-60 rounded-lg border object-contain"
        />
      ) : images.length > 1 ? (
        <Attachments variant="grid" className="justify-end">
          {images.map((file, index) => (
            <Attachment key={index} data={{ ...file, id: String(index) }}>
              <AttachmentPreview />
            </Attachment>
          ))}
        </Attachments>
      ) : null}
      {others.length > 0 ? (
        <Attachments variant="list" className="w-64">
          {others.map((file, index) => (
            <Attachment key={index} data={{ ...file, id: `f${index}` }}>
              <AttachmentPreview />
              <AttachmentInfo showMediaType />
            </Attachment>
          ))}
        </Attachments>
      ) : null}
    </div>
  );
}
